// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-i_fb","catalogByServiceItem__title":"c-i_fc"};